export function getDirectChatId(a: string, b: string): string {
  const left = (a || '').trim();
  const right = (b || '').trim();
  if (!left || !right) return `${left}::${right}`;
  return left < right ? `${left}::${right}` : `${right}::${left}`;
}

export function getDirectChatParticipants(a: string, b: string): [string, string] {
  const left = (a || '').trim();
  const right = (b || '').trim();
  return left < right ? [left, right] : [right, left];
}
